import { Title } from '@bancobarigui/barihaus';
import { AppstoreOutlined } from '@ant-design/icons';

interface WorkspaceHeaderProps {
  hasGroups: boolean;
  onAddGroup: () => void;
}

export function WorkspaceHeader({ hasGroups: _hasGroups, onAddGroup: _onAddGroup }: WorkspaceHeaderProps) {
  return (
    <>
      <div className="flex items-start mb-6">
        <AppstoreOutlined className="text-blue-500 mr-3 text-2xl" />
        <Title level={4} className="mt-0">Estrutura do Formulário</Title>
      </div>

      <p className="text-gray-500 dark:text-gray-400 mb-6">
        Crie e organize a estrutura do seu checklist através de grupos, seções e perguntas.
        Você pode reordenar os elementos usando drag and drop.
      </p>
    </>
  );
}
